import { createContext } from 'react';
import { noop } from '../..';
export var ModalContext = /*#__PURE__*/createContext({
  onHide: noop
});